module.exports = __webpack_public_path__ + "static/media/olivia-wilde.6a49d0da.jpg";